import React, { useState, useEffect } from "react";
import Select from "react-select";
import { Search } from 'lucide-react';
import { MdPrint } from "react-icons/md";
import classes from "./UserProvince.module.css"
import plus from "../../../../Assets/plus.svg"
import EyeIcon from "../../../../Assets/new-eye.svg"
import DeleteIcon from "../../../../Assets/new-delete.svg"
import { Spinner, Badge, Button, Modal, Form, Alert } from 'react-bootstrap';
import HeaderNav from "../../../Budget/Budget Dashboard/HeaderNav/HeaderNav.js";
import axios from "axios";
import { BASE_URL } from "../../../../Components/Styles/API/API";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const UserProvince = () => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [show, setShow] = useState(false);
  const [continentDescription, setContinentDescription] = useState("");
  const [selectedReportTo, setSelectedReportTo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [show1, setShow1] = useState(false);
  const [continents, setContinents] = useState([]);
  const [regions, setRegions] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedContinent, setSelectedContinent] = useState(null);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [selectedContinentFilter, setSelectedContinentFilter] = useState(null);
  const [selectedRegionFilter, setSelectedRegionFilter] = useState(null);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [bearer, setBearer] = useState('');
  const navigate = useNavigate();
  const [tableData, setTableData] = useState([]);
  const [tableData2, setTableData2] = useState([]);
  const [tableData12, setTableData12] = useState([]);
  const [tableData3, setTableData3] = useState([]);
  const [tableData33, setTableData33] = useState([]);
  const [loads, setLoads] = useState(false);
  const [provinceLoading, setProvinceLoading] = useState(false);

  // New states for Add Province modal
  const [showAddProvince, setShowAddProvince] = useState(false);
  const [provinceDescription, setProvinceDescription] = useState("");
  const [selectedContinentModal, setSelectedContinentModal] = useState(null);
  const [selectedRegionModal, setSelectedRegionModal] = useState(null);
  const [asAtDate, setAsAtDate] = useState("");
  const [regionsModal, setRegionsModal] = useState([]);
  const [creatingProvince, setCreatingProvince] = useState(false);
  const [tableData44, setTableData44] = useState([]);
  const [tableData1, setTableData1] = useState([]);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(150);

  // Select styles with proper font size
  const selectStyles = {
    container: (provided) => ({
      ...provided,
      width: '100%',
      fontSize: '14px',
    }),
    control: (provided) => ({
      ...provided,
      minHeight: "38px",
      fontSize: '14px',
      border: '1px solid #ced4da',
      '&:hover': {
        borderColor: '#80bdff',
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: '14px',
      color: '#495057',
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: '14px',
      backgroundColor: state.isFocused ? "#e9ecef" : "white",
      color: "#495057",
      '&:active': {
        backgroundColor: '#007bff',
        color: 'white'
      }
    }),
    menu: (provided) => ({
      ...provided,
      maxHeight: "300px",
      overflowY: "auto",
      fontSize: '14px',
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    placeholder: (provided) => ({
      ...provided,
      fontSize: '14px',
      color: '#6c757d',
    }),
    input: (provided) => ({
      ...provided,
      fontSize: '14px',
      color: '#495057',
    }),
  };

  // Get token from localStorage
  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      if (value !== null) {
        setBearer(value);
      }
    } catch (e) {
      console.error('Failed to fetch token from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  // Headers function to ensure fresh token
  const getHeaders = () => {
    const token = bearer || localStorage.getItem('userToken');
    return {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    };
  };

  // Print View handler
  const handlePrintView = () => {
    navigate('/budget/charts_of_account/Province');
  };

  // Modal handlers for Add Province
  const handleCloseAddProvince = () => {
    setShowAddProvince(false);
    resetAddProvinceForm();
  };

  const handleShowAddProvince = () => {
    setShowAddProvince(true);
  };

  const resetAddProvinceForm = () => {
    setProvinceDescription("");
    setSelectedContinentModal(null);
    setSelectedRegionModal(null);
    setAsAtDate("");
    setRegionsModal([]);
  };

  // Fetch regions based on selected continent in modal
  const fetchRegionsByContinentModal = async (continentId) => {
    if (!continentId) {
      setRegionsModal([]);
      return;
    }

    try {
      const response = await axios.get(`${BASE_URL}/continents/getcontinentregions?continent_id=${continentId}`, { headers: getHeaders() });
      console.log("Regions API Response for Modal:", response.data);

      let regionsData = [];
      if (response.data.status && response.data.data) {
        if (Array.isArray(response.data.data)) {
          regionsData = response.data.data;
        }
        else if (response.data.data.regions && Array.isArray(response.data.data.regions)) {
          regionsData = response.data.data.regions;
        }
        else {
          const dataObj = response.data.data;
          for (const key in dataObj) {
            if (Array.isArray(dataObj[key])) {
              regionsData = dataObj[key];
              break;
            }
          }
        }
      } else if (Array.isArray(response.data)) {
        regionsData = response.data;
      } else if (response.data.data && Array.isArray(response.data.data)) {
        regionsData = response.data.data;
      }

      if (!Array.isArray(regionsData)) {
        console.error("Regions data is not an array:", regionsData);
        regionsData = [];
      }

      const regionOptions = regionsData.map(region => ({
        value: region.id,
        label: region.description || 'Unnamed Region'
      }));

      setRegionsModal(regionOptions);
    } catch (error) {
      console.error("Error fetching regions for modal:", error);
      setRegionsModal([]);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to load regions for selected continent'
      });
    }
  };

  // Handle continent selection in modal
  const handleContinentChangeModal = (selectedOption) => {
    setSelectedContinentModal(selectedOption);
    setSelectedRegionModal(null);
    if (selectedOption) {
      fetchRegionsByContinentModal(selectedOption.value);
    } else {
      setRegionsModal([]);
    }
  };

  // Fetch all provinces and initialize tableData44
  const fetchProvinces = async () => {
    setProvinceLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/provinces`, { headers: getHeaders() });

      const prov = response.data?.data.provinces;
      setTableData2(prov);
      setTableData44(prov);
      console.log(prov, "Testing for Provinces");
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }
      setTableData2([]);
      setTableData44([]);
      console.error('Error fetching provinces:', errorMessage);
    } finally {
      setProvinceLoading(false);
    }
  };

  // FIXED: Filter provinces by continent and region using the new API
  const fetchProvincesByFilter = async (continentId = null, regionId = null) => {
    setLoads(true);
    try {
      let url = `${BASE_URL}/provinces/get-by-filter`;

      const params = new URLSearchParams();
      if (continentId && continentId !== 'all') {
        params.append('continent_id', continentId);
      }
      if (regionId && regionId !== 'all') {
        params.append('region_id', regionId);
      }

      if (params.toString() === '') {
        setTableData44(tableData2);
        setLoads(false);
        return;
      }

      url += `?${params.toString()}`;

      const response = await axios.get(url, { headers: getHeaders() });
      console.log("Filter API Response:", response.data);

      let filteredProvinces = [];

      if (response.data.status && response.data.data) {
        if (Array.isArray(response.data.data)) {
          filteredProvinces = response.data.data;
        } else if (response.data.data.provinces && Array.isArray(response.data.data.provinces)) {
          filteredProvinces = response.data.data.provinces;
        } else {
          const dataObj = response.data.data;
          for (const key in dataObj) {
            if (Array.isArray(dataObj[key])) {
              filteredProvinces = dataObj[key];
              break;
            }
          }
        }
      }

      setTableData44(filteredProvinces);
      console.log("Filtered Provinces:", filteredProvinces);

    } catch (error) {
      console.error("Error filtering provinces:", error);
      let errorMessage = 'Failed to filter provinces';

      if (error.response?.data?.message?.continent_id) {
        errorMessage = `Invalid continent selected: ${error.response.data.message.continent_id[0]}`;
      } else if (error.response && error.response.data && error.response.data.message) {
        errorMessage = typeof error.response.data.message === 'string'
          ? error.response.data.message
          : JSON.stringify(error.response.data.message);
      }

      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: errorMessage
      });

      setTableData44(tableData2);
    } finally {
      setLoads(false);
    }
  };

  // Create province function using the new API endpoint
  const createProvinceNew = async () => {
    if (!provinceDescription.trim()) {
      Swal.fire({
        icon: 'warning',
        title: 'Validation Error',
        text: 'Please enter province description'
      });
      return;
    }

    if (!selectedContinentModal) {
      Swal.fire({
        icon: 'warning',
        title: 'Validation Error',
        text: 'Please select a continent'
      });
      return;
    }

    if (!selectedRegionModal) {
      Swal.fire({
        icon: 'warning',
        title: 'Validation Error',
        text: 'Please select a region'
      });
      return;
    }

    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to create this province?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Create",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setCreatingProvince(true);
        try {
          const requestData = {
            description: provinceDescription,
            continent_id: selectedContinentModal.value,
            region_id: selectedRegionModal.value,
            as_at: asAtDate || new Date().toISOString().split('T')[0]
          };

          const response = await axios.post(
            `${BASE_URL}/provinces/create_province`,
            requestData,
            { headers: getHeaders() }
          );

          handleCloseAddProvince();
          fetchProvinces();

          Swal.fire({
            title: "Success!",
            text: response.data.message || "Province created successfully",
            icon: "success",
            confirmButtonText: "OK",
          });
        } catch (error) {
          let errorMessage = "Something went wrong.";
          if (error.response && error.response.data.message) {
            errorMessage =
              typeof error.response.data.message === "string"
                ? error.response.data.message
                : JSON.stringify(error.response.data.message);
          }

          Swal.fire({
            title: "Error!",
            text: errorMessage,
            icon: "error",
            confirmButtonText: "OK",
          });
        } finally {
          setCreatingProvince(false);
        }
      }
    });
  };


  // Update province - FIXED with correct endpoint
 

  // Delete province - FIXED with GET method
  const deleteProvince = async (provinceId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this province?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Delete",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#d33",
    }).then(async (result) => {
      if (result.isConfirmed) {
        // Show loading state immediately
        Swal.fire({
          title: 'Deleting...',
          text: 'Please wait while we delete the province',
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        try {
          // Use GET request with query parameters for delete
          const response = await axios.get(
            `${BASE_URL}/provinces/delete_province`,
            {
              params: { id: provinceId },
              headers: getHeaders()
            }
          );

          if (response.data.status || response.data.success) {
            setSuccess("Province deleted successfully");
            fetchProvinces();

            Swal.fire({
              title: "Deleted!",
              text: response.data.message || "Province deleted successfully",
              icon: "success",
              confirmButtonText: "OK",
            });
          }
        } catch (error) {
          console.error("Error deleting province:", error);
          let errorMessage = "Something went wrong while deleting the province.";

          if (error.response?.status === 401) {
            errorMessage = "Session expired. Please log in again.";
            localStorage.removeItem('userToken');
            navigate('/login');
          } else if (error.response?.data?.message) {
            errorMessage = error.response.data.message;
          }

          Swal.fire({
            title: "Error!",
            text: errorMessage,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      }
    });
  };

  const fetchContinents = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/continents`, { headers: getHeaders() });

      const results = response.data?.data;

      const options = results.map((item) => ({
        label: item.description,
        value: item.id,
      }));

      const continentsWithAll = [
        { label: "All Continents", value: "all" },
        ...options
      ];

      setTableData(results);
      setTableData12(continentsWithAll);
    } catch (error) {
      let errorMessage = 'An error occurred while fetching continents. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }

      setTableData([]);
      setTableData12([{ label: "All Continents", value: "all" }]);
      console.error('Error fetching continents:', errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchRegions = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/regions`, { headers: getHeaders() });

      const reg = response.data?.data?.regions;

      const regionsWithAll = [
        { label: "All Regions", value: "all" },
        ...(Array.isArray(reg) ? reg.map(region => ({
          label: region.description,
          value: region.id,
        })) : [])
      ];

      setTableData1(reg);
      setTableData33(regionsWithAll);
    } catch (error) {
      let errorMessage = 'An error occurred while fetching regions.';
      if (error.response && error.response.data && error.response.data.message) {
        errorMessage = typeof error.response.data.message === 'string'
          ? error.response.data.message
          : JSON.stringify(error.response.data.message);
      }

      setTableData1([]);
      setTableData33([{ label: "All Regions", value: "all" }]);
      console.error('Error fetching regions:', errorMessage);
    }
  };

  const fetchSubContinents = async (selectedContinent, selectedContinentFilter) => {
    if (!selectedContinent || selectedContinent === 'all') {
      setTableData3([]);
      setTableData33([{ label: "All Regions", value: "all" }]);
      return;
    }

    try {
      const response = await axios.get(`${BASE_URL}/continents/getcontinentregions?continent_id=${selectedContinent  || selectedContinentFilter}`, { headers: getHeaders() });
      const subCont = response.data?.data;

      const regionsWithAll = [
        { label: "All Regions", value: "all" },
        ...(Array.isArray(subCont) ? subCont.map((item) => ({
          label: item.description,
          value: item.id,
        })) : [])
      ];

      setTableData3(subCont);
      setTableData33(regionsWithAll);
      console.log("Regions:", subCont);
    } catch (error) {
      let errorMessage = 'An error occurred while fetching regions for continent.';
      if (error.response && error.response.data && error.response.data.message) {
        errorMessage = typeof error.response.data.message === 'string'
          ? error.response.data.message
          : JSON.stringify(error.response.data.message);
      }

      setTableData3([]);
      setTableData33([{ label: "All Regions", value: "all" }]);
      console.error('Error fetching sub-continents:', errorMessage);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchContinents();
      fetchRegions();
      fetchProvinces();
    }
  }, [bearer]);

  useEffect(() => {
    if (bearer && selectedContinent) {
      if (selectedContinent.value === 'all') {
        setTableData33([{ label: "All Regions", value: "all" }]);
        setSelectedRegion(null);
      } else {
        fetchSubContinents(selectedContinent.value);
      }
    } else if (bearer && !selectedContinent) {
      setTableData33([{ label: "All Regions", value: "all" }]);
      setSelectedRegion(null);
    }
  }, [bearer, selectedContinent]);

  const handleContinentFilter = (selectedOption) => {
    setSelectedContinent(selectedOption);
    setSelectedRegion(null);
    setCurrentPage(1); // Reset to first page when filter changes

    if (!selectedOption || selectedOption.value === 'all') {
      setTableData44(tableData2);
    } else {
      fetchProvincesByFilter(selectedOption.value, null);
    }
  };

  const handleRegionFilter = (selectedOption) => {
    setSelectedRegion(selectedOption);
    setCurrentPage(1); // Reset to first page when filter changes

    if (!selectedOption || selectedOption.value === 'all') {
      if (selectedContinent && selectedContinent.value !== 'all') {
        fetchProvincesByFilter(selectedContinent.value, null);
      } else {
        setTableData44(tableData2);
      }
    } else {
      const continentId = selectedContinent && selectedContinent.value !== 'all' ? selectedContinent.value : null;
      fetchProvincesByFilter(continentId, selectedOption.value);
    }
  };

  // const handleShow1 = (province) => {
  //   setSelectedContinent(province);
  //   setContinentDescription(province.description);

  //   // Set region and continent data for display in the modal
  //   setSelectedRegion(province.region ? {
  //     value: province.region.id,
  //     label: province.region.description
  //   } : null);

  //   setSelectedContinentFilter(province.continent ? {
  //     value: province.continent.id,
  //     label: province.continent.description
  //   } : null);

  //   setShow1(true);
  //   setError("");
  // };

  const handleClose1 = () => {
    setShow1(false);
    setSelectedContinent(null);
    setSelectedRegion(null);
    setSelectedContinentFilter(null);
    setError("");
  };

  const handleShow = () => {
    setShow(true);
    setError("");
  };

  const handleClose = () => {
    setShow(false);
    setError("");
  };

  // Pagination logic
  const filteredProvinces = Array.isArray(tableData44)
    ? tableData44.filter(province =>
      province?.description?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      province?.id?.toString().includes(searchTerm)
    )
    : [];

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentProvinces = filteredProvinces.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredProvinces.length / itemsPerPage);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Go to first page
  const goToFirstPage = () => setCurrentPage(1);

  // Go to last page
  const goToLastPage = () => setCurrentPage(totalPages);

  // Generate page numbers to display
  const getPageNumbers = () => {
    const pageNumbers = [];
    const maxPagesToShow = 2;

    if (totalPages <= maxPagesToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      const startPage = Math.max(1, currentPage - 1);
      const endPage = Math.min(totalPages, currentPage + 1);

      for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
      }
    }

    return pageNumbers;
  };

  function getContinentColors(name) {
    if (!name) return { backgroundColor: '#f0f0f0', color: '#666' };

    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    const hue = Math.abs(hash) % 360;

    return {
      backgroundColor: `hsl(${hue}, 70%, 90%)`,
      color: `hsl(${hue}, 70%, 30%)`,
    };
  }

  // Format date for display
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';

    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const [showUpdateProvince, setShowUpdateProvince] = useState(false);

const [updateProvinceId, setUpdateProvinceId] = useState(null);
const [updateProvinceDescription, setUpdateProvinceDescription] = useState('');

const [selectedContinentUpdate, setSelectedContinentUpdate] = useState(null);
const [selectedRegionUpdate, setSelectedRegionUpdate] = useState(null);

const [regionsUpdate, setRegionsUpdate] = useState([]);

const fetchRegionsForUpdate = async (continentId) => {
  try {
    const res = await axios.get(
      `${BASE_URL}/continents/getcontinentregions?continent_id=${continentId}`,
      { headers: getHeaders() }
    );

    const regions = res.data?.data || [];

    const formatted = regions.map(r => ({
      value: r.id,
      label: r.description,
    }));

    setRegionsUpdate(formatted);
  } catch (err) {
    setRegionsUpdate([]);
  }
};


const handleShow1 = async (province) => {
  // store province id
  setUpdateProvinceId(province.id);

  // set province name
  setUpdateProvinceDescription(province.description || '');

  // set continent
  const continentOption = province.continent
    ? {
        value: province.continent.id,
        label: province.continent.description,
      }
    : null;

  setSelectedContinentUpdate(continentOption);

  // fetch regions for that continent
  if (continentOption) {
    await fetchRegionsForUpdate(continentOption.value);
  }

  // set region AFTER regions are loaded
  const regionOption = province.region
    ? {
        value: province.region.id,
        label: province.region.description,
      }
    : null;

  setSelectedRegionUpdate(regionOption);

  setShowUpdateProvince(true);
};

const handleContinentChangeUpdate = async (continent) => {
  setSelectedContinentUpdate(continent);
  setSelectedRegionUpdate(null);

  if (continent) {
    await fetchRegionsForUpdate(continent.value);
  } else {
    setRegionsUpdate([]);
  }
};


const updateProvince = async () => {
  if (
    !updateProvinceDescription.trim() ||
    !selectedContinentUpdate ||
    !selectedRegionUpdate
  ) {
    setError("Please complete all required fields");
    return;
  }

  Swal.fire({
    title: "Are you sure?",
    text: "Do you want to update this province?",
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Yes, Update",
    cancelButtonText: "Cancel",
  }).then(async (result) => {
    if (!result.isConfirmed) return;

    setIsLoading(true);

    try {
      const requestData = {
        id: updateProvinceId, // ✅ FROM STATE
        description: updateProvinceDescription,
        continent_id: selectedContinentUpdate.value,
        region_id: selectedRegionUpdate.value,
      };

      const response = await axios.post(
        `${BASE_URL}/provinces/update_province`,
        requestData,
        { headers: getHeaders() }
      );

      Swal.fire({
        title: "Success!",
        text: response.data.message || "Province updated successfully",
        icon: "success",
      });

      setShowUpdateProvince(false);
      fetchProvinces();
    } catch (error) {
      let errorMessage = "Something went wrong.";
      if (error.response?.data?.message) {
        errorMessage =
          typeof error.response.data.message === "string"
            ? error.response.data.message
            : JSON.stringify(error.response.data.message);
      }

      Swal.fire({
        title: "Error!",
        text: errorMessage,
        icon: "error",
      });
    } finally {
      setIsLoading(false);
    }
  });
};

  return (
    <div>
      <HeaderNav />

      {/* New Add Province Modal */}
      <Modal show={showAddProvince} onHide={handleCloseAddProvince} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add New Province</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Continent *</Form.Label>
              <Select
                value={selectedContinentModal}
                onChange={handleContinentChangeModal}
                options={tableData12}
                placeholder="Select Continent"
                isClearable
                styles={selectStyles}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Region *</Form.Label>
              <Select
                value={selectedRegionModal}
                onChange={setSelectedRegionModal}
                options={regionsModal}
                placeholder="Select Region"
                isClearable
                isDisabled={!selectedContinentModal}
                styles={selectStyles}
              />
              <Form.Text className="text-muted">
                Please select a continent first to choose a region
              </Form.Text>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Province Description *</Form.Label>
              <Form.Control
                type="text"
                value={provinceDescription}
                onChange={(e) => setProvinceDescription(e.target.value)}
                placeholder="Enter province description"
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseAddProvince}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={createProvinceNew}
            disabled={creatingProvince || !provinceDescription.trim() || !selectedContinentModal || !selectedRegionModal}
          >
            {creatingProvince ? (
              <>
                <Spinner size="sm" animation="border" className="me-2" />
                Creating...
              </>
            ) : (
              'Create Province'
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Update Province Modal with Editable Continent and Region */}
      <Modal show={show1} onHide={handleClose1} animation={false} size="md">
        <Modal.Header closeButton>
          <Modal.Title>Update Province</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {error && <Alert variant="danger">{error}</Alert>}
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Province Description *</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Province Description"
                value={continentDescription}
                onChange={(e) => setContinentDescription(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Continent *</Form.Label>
              <Select
                value={selectedContinentFilter}
                onChange={setSelectedContinentFilter}
                options={tableData12.filter(opt => opt.value !== 'all')}
                placeholder="Select Continent"
                styles={selectStyles}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Region *</Form.Label>
              <Select
                value={selectedRegion}
                onChange={setSelectedRegion}
                options={tableData33.filter(opt => opt.value !== 'all')}
                placeholder="Select Region"
                styles={selectStyles}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose1}>
            Cancel
          </Button>
          <Button
            className={classes.customButton}
            onClick={updateProvince}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <Spinner size="sm" />
                <span style={{ marginLeft: "5px" }}>Updating...</span>
              </>
            ) : (
              "Save Changes"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showUpdateProvince} onHide={() => setShowUpdateProvince(false)} centered>
  <Modal.Header closeButton>
    <Modal.Title>Update Province</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <Form>
      <Form.Group className="mb-3">
        <Form.Label>Continent *</Form.Label>
        <Select
          value={selectedContinentUpdate}
          onChange={handleContinentChangeUpdate}
          options={tableData12}
          isClearable
          styles={selectStyles}
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Region *</Form.Label>
        <Select
          value={selectedRegionUpdate}
          onChange={setSelectedRegionUpdate}
          options={regionsUpdate}
          isClearable
          isDisabled={!selectedContinentUpdate}
          styles={selectStyles}
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Province Description *</Form.Label>
        <Form.Control
          type="text"
          value={updateProvinceDescription}
          onChange={(e) => setUpdateProvinceDescription(e.target.value)}
        />
      </Form.Group>
    </Form>
  </Modal.Body>

  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowUpdateProvince(false)}>
      Cancel
    </Button>

    <Button
      variant="primary"
      onClick={updateProvince}
      // disabled={
      //   !updateProvinceDescription.trim() ||
      //   !selectedContinentUpdate ||
      //   !selectedRegionUpdate
      // }
    >
      Update Province
    </Button>
  </Modal.Footer>
</Modal>


      <div className={classes.topContainer}>
        <div className={classes.topNavBars}>
          <Button className={classes.buttonsNav}>Remitances</Button>
          <Button className={classes.buttonsNav}>Petty Cash</Button>
          <Button className={classes.buttonsNav}>Supplier's Payment</Button>
          <Button className={classes.buttonsNav}>Customer's Leger</Button>
        </div>
        <div style={{ marginTop: 24 }} />
        <h3 className={classes.topText}>Manage Province</h3>
        <p className={classes.prgText}>Add, View, Edit, and Delete Province.</p>

        <div className={classes.subContainer} style={{ display: 'flex', alignItems: 'center', gap: '15px', flexWrap: 'nowrap', justifyContent: 'space-between' }}>
          {/* Left side: Continent and Region filters */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px', flex: 1 }}>
            {/* Continent Filter */}
            <div style={{ minWidth: '200px' }}>
              <label className={classes.filterLabel}>Continent</label>
              <Select
                onChange={handleContinentFilter}
                options={tableData12}
                value={selectedContinent}
                menuPortalTarget={document.body}
                styles={selectStyles}
                placeholder="Select Continent"
                isClearable
                className={classes.filterSelect}
              />
            </div>

            {/* Region Filter */}
            <div style={{ minWidth: '200px' }}>
              <label className={classes.filterLabel}>Region</label>
              <Select
                onChange={handleRegionFilter}
                options={tableData33}
                value={selectedRegion}
                menuPortalTarget={document.body}
                styles={selectStyles}
                placeholder="Select Region"
                isClearable
                className={classes.filterSelect}
                isDisabled={!selectedContinent}
              />
            </div>
          </div>

          {/* Middle: Total Provinces */}
          <div className={classes.statCount} style={{ flexShrink: 0, margin: '0 auto', marginRight: '5%', marginTop: '25px' }}>
            <div className={classes.statConn}>
              <p className={classes.txtHd}>Provinces</p>
              {provinceLoading ? (
                <div className={classes.skeleton} style={{ width: '40px', height: '24px', marginTop: '-10px' }}></div>
              ) : (
                <p className={classes.txtHds}>{filteredProvinces.length}</p>
              )}
            </div>
          </div>

          {/* Right side: Search, Print View, and Add New Province */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px', flexShrink: 0, marginTop: '25px' }}>
            {/* Search Input */}
            <div className={classes.searchInputWrapper}>
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className={classes.searchInput}
                placeholder="Search provinces..."
              />
              <Search className={classes.searchIcon} size={16} />
            </div>

            {/* Print View Button */}
            <div>
              <button className={classes.loanBtn} onClick={handlePrintView}>
                <MdPrint size={18} style={{ marginRight: '8px' }} />
                Print
              </button>
            </div>

            {/* Add New Province Button */}
            <div>
              <button className={classes.loanBtn} onClick={handleShowAddProvince}>
                <img src={plus} alt="plus" /> Add New
              </button>
            </div>
          </div>
        </div>

        <div className={classes.tableContainer}>
          <table className={classes.tableTable}>
            <thead className={classes.tableHeader}>
              <tr>
                <th>#</th>
                <th>Province</th>
                <th>Region</th>
                <th>Continent</th>
                <th>Created Date</th>
                <th>Updated Date</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {provinceLoading || loads ? (
                Array.from({ length: 7 }).map((_, index) => (
                  <tr key={`skeleton-${index}`}>
                    <td className={classes.textby}>
                      <div className={classes.skeleton} style={{ width: '30px', height: '20px' }}></div>
                    </td>
                    <td className={classes.textby}>
                      <div className={classes.skeleton} style={{ width: '150px', height: '20px' }}></div>
                    </td>
                    <td className={classes.textby}>
                      <div className={classes.skeleton} style={{ width: '100px', height: '20px' }}></div>
                    </td>
                    <td className={classes.textby}>
                      <div className={classes.skeleton} style={{ width: '100px', height: '20px' }}></div>
                    </td>
                    <td className={classes.textby}>
                      <div className={classes.skeleton} style={{ width: '100px', height: '20px' }}></div>
                    </td>
                    <td className={classes.textby}>
                      <div className={classes.skeleton} style={{ width: '100px', height: '20px' }}></div>
                    </td>
                    <td className={classes.textby}>
                      <div className={classes.skeleton} style={{ width: '80px', height: '20px' }}></div>
                    </td>
                    <td className={classes.btnAction}>
                      <div style={{ display: 'flex', gap: '10px' }}>
                        <div className={classes.skeleton} style={{ width: '20px', height: '20px', borderRadius: '4px' }}></div>
                      </div>
                    </td>
                  </tr>
                ))
              ) : currentProvinces.length > 0 ? (
                currentProvinces.map((province, index) => (
                  <tr key={province.id || index}>
                    <td className={classes.textby}>{indexOfFirstItem + index + 1}</td>
                    <td className={classes.textby}>
                      <span className={classes.statucColor}>
                        {province.description || 'N/A'}
                      </span>
                    </td>
                    <td className={classes.textby}>
                      {province.region?.description || 'N/A'}
                    </td>
                    <td className={classes.textby}>
                      {province.continent?.description || 'N/A'}
                    </td>
                    <td className={classes.textby}>
                      {formatDate(province.created_at)}
                    </td>
                    <td className={classes.textby}>
                      {formatDate(province.updated_at)}
                    </td>
                    <td className={classes.textby}>
                      <Badge bg={province.type === "2" ? "success" : "warning"}>
                        {province.type === "2" ? "Updated" : "Not Updated"}
                      </Badge>
                    </td>
                    <td className={classes.btnAction}>
                      <button
                        style={{ backgroundColor: "transparent", border: 0, cursor: "pointer", marginRight: '10px' }}
                        onClick={() => handleShow1(province)}
                        title="View/Edit"
                      >
                        <img src={EyeIcon} alt="View" />
                      </button>
                      <button
                        style={{ backgroundColor: "transparent", border: 0, cursor: "pointer" }}
                        onClick={() => deleteProvince(province.id)}
                        title="Delete"
                      >
                        <img src={DeleteIcon} alt="Delete" />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center p-4">
                    {provinceLoading || loads ? "Loading provinces..." :
                      searchTerm ? "No provinces found matching your search" :
                        "No provinces available. Create your first province!"}
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          {/* Pagination - WORKING VERSION */}
          {!provinceLoading && !loads && filteredProvinces.length > 0 && (
            <div className={classes.paginationStyle}>
              <div className={classes.footerSubOne}>
                <button
                  className={classes.btnFirst}
                  onClick={goToFirstPage}
                  disabled={currentPage === 1}
                >
                  First
                </button>
                <span className={classes.ftOne}>
                  {getPageNumbers().map(number => (
                    <button
                      key={number}
                      className={`${classes.pageNumber} ${currentPage === number ? classes.active : ''}`}
                      onClick={() => paginate(number)}
                    >
                      {number}
                    </button>
                  ))}
                </span>
                <button
                  className={classes.btnSec}
                  onClick={goToLastPage}
                  disabled={currentPage === totalPages || totalPages === 0}
                >
                  Last
                </button>
              </div>
              <p className={classes.displayPag}>
                Displaying {indexOfFirstItem + 1}-{Math.min(indexOfLastItem, filteredProvinces.length)} of {filteredProvinces.length}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default UserProvince